module.exports = __webpack_public_path__ + "static/media/business_icon.396e5047.svg";